import { UseTimeAgoMessages, UseTimeAgoUnitNamesDefault } from '@vueuse/core';

export const useTimeAgoShortMessages: UseTimeAgoMessages<UseTimeAgoUnitNamesDefault> = {
  justNow: 'just now',
  past: (n) => (n.match(/\d/) ? `${n} ago` : n),
  future: (n) => (n.match(/\d/) ? `in ${n}` : n),
  month: (n) => `${n}mo`,
  year: (n) => `${n}y`,
  day: (n) => `${n}d`,
  week: (n) => `${n}w`,
  hour: (n) => `${n}h`,
  minute: (n) => `${n}m`,
  second: (n) => `${n}s`,
  invalid: '',
};
